import styled from "styled-components";
// import { tooltipClasses } from "@mui/material/Tooltip";

// interface Props {
//     custom: string;
// }

export const StyledTooltip = styled.div`
  .tooltip {
    background-color: brown !important;
  }

  p {
    font-size: 1.8rem;
  }

  .question-icon {
    color: #425466;
    transform: scale(1.3);
  }
`;
